import { render, staticRenderFns } from "./SelectedReceivingMethod.vue?vue&type=template&id=762ecf30&"
import script from "./SelectedReceivingMethod.vue?vue&type=script&lang=js&"
export * from "./SelectedReceivingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports